import { ReactNode } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import LoginPage from './LoginPage';

interface AuthRouteProps {
  children: ReactNode;
}

const AuthRoute = ({ children }: AuthRouteProps) => {
  const isAuthenticated = useIsAuthenticated();
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
};

export default AuthRoute;
